import { IAPIRoutes } from "../../../../config";

export type IBedExitsRepository = ReturnType<typeof BedExitsRepositoryFactory>;

export const BedExitsRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { POST, GET, DELETE, PATCH, PUT } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const GetBedExitEventList: IBedExitEventListAPI = async (payload) =>
    GET(
      APIRoutes.apiGetBedExitEventList.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const GetBedExitSettingByUserPrefAPI: IBedExitSettingsAPI = async (payload) =>
    GET(
      APIRoutes.apiGetBedExitSettingsByUserPref.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const AddBedExitsAPI: IAddBedExitsAPI = async (payload) =>
    POST(APIRoutes.apiAddBedExits, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });

  const AddBedExitsAPIv3API: IAddBedExitsAPIV3API = async (
    payload,
    clinic_id
  ) =>
    POST(
      APIRoutes.apiAddBedExitsV3.replace("{clinic_id}", clinic_id.toString()),
      { settings: payload },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const GetBedExitFacilityReportAPI: IPostBedExitFacilityReportAPI = async (
    payload
  ) =>
    POST(
      APIRoutes.apiGetBedExitFacilityReport.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      payload,
      { Authorization: `Bearer ${await getAuthenticationToken()}` }
    );

  const UpdateNotificationFromPatientChartAPI: IUpdateNotificationSettingsFromPatientChartAPI =
    async (payload) =>
      PUT(APIRoutes.apiUpdatePatientNotificationSettings, payload, {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      });

  const UpdateNotificationFromPatientChartAPIv2: IUpdateNotificationSettingsFromPatientChartAPIv2 =
    async (payload) =>
      PUT(APIRoutes.apiUpdatePatientNotificationSettingsV2, payload, {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      });

  const UpdateBedExitsAPI: IUpdateBedExitsAPI = async (payload) =>
    PATCH(APIRoutes.apiUpdateBedExits, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });

  const UpdateBedExitsTimesAPI: IUpdateBedExitsTimesAPI = async (payload) =>
    PATCH(APIRoutes.apiUpdateBedExitsTime, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });

  const DeleteBedExitsAPI: IDeleteBedExitsAPI = async (payload) =>
    DELETE(APIRoutes.apiAddBedExits, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });

  const UpdateCombineBedExitsAPI: IUpdateNotificationSettingsFromPatientChartAPI =
    async (payload) =>
      PUT(APIRoutes.apiUpdateCombineBedExits, payload, {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      });

  return {
    AddBedExitsAPI,
    UpdateBedExitsAPI,
    DeleteBedExitsAPI,
    GetBedExitSettingByUserPrefAPI,
    UpdateBedExitsTimesAPI,
    UpdateNotificationFromPatientChartAPI,
    GetBedExitEventList,
    UpdateCombineBedExitsAPI,
    GetBedExitFacilityReportAPI,
    UpdateNotificationFromPatientChartAPIv2,
    AddBedExitsAPIv3API,
  };
};
